import { Component, OnInit, ViewChild } from '@angular/core';
import { NoEmptyString } from '../../interfaces/no-empty-string.validator';
import { ISupplierFeedback } from '../../interfaces/supplier-feedback/supplier-feedback';
import { ActivatedRoute, Router } from '@angular/router';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  Validators,
  NgForm,
} from '@angular/forms';
import { MessageService } from 'primeng';
import { Message } from '../../classes/Message';
import { SelectItem } from 'primeng';
import { SupplierFeedbackService } from '../../services/supplier-feedback.service';
import { getCombinedParameters } from '../../utils/getCombinedParameters';

@Component({
  selector: 'supplier-feedback-details',
  styleUrls: ['./supplier-feedback-details.component.css'],
  templateUrl: './supplier-feedback-details.component.html',
})
// this component is used to show all existing supplier feedback records from the main menu
export class SupplierFeedbackDetailsComponent implements OnInit {
  public feedback: ISupplierFeedback;
  private id: any;
  public isLoading: boolean = true;
  public notFound: boolean = false;
  public backTo: string;
  public saveFeedbackDetails: any = {};
  public saveOutcomeDetails: any = {};

  public outcomes: SelectItem[] = [];
  public selectedOutcome: any = null;

  @ViewChild('addFeedbackDetailForm')
  private form: NgForm;
  messageControl: UntypedFormControl;
  newMessageform: UntypedFormGroup;

  public isBusyLoadOutcomes: boolean;
  public loadOutcomesError: boolean = false;

  constructor(
    private feedbackService: SupplierFeedbackService,
    private route: ActivatedRoute,
    private router: Router,
    public messageService: MessageService,
    public fb: UntypedFormBuilder,
  ) {}

  ngOnInit(): void {
    getCombinedParameters(this.route).subscribe((params) => {
      this.id = params['id'];
      this.backTo = params['backTo'];

      this.messageControl = this.fb.control(
        'newMessage',
        Validators.compose([Validators.required, Validators.maxLength(3072), NoEmptyString]),
      );

      this.newMessageform = this.fb.group({
        newMessage: this.messageControl,
      });

      this.feedbackService.get(this.id).then((result) => {
        this.feedback = result;

        if (!result) this.notFound = true;
        else {
          this.saveFeedbackDetails['supplierFeedbackId'] = this.feedback.id;
          this.saveOutcomeDetails['supplierFeedbackId'] = this.feedback.id;
        }

        this.isLoading = false;
      });

      this.isBusyLoadOutcomes = true;
      this.feedbackService
        .getOutcomes()
        .then((result) => {
          this.isBusyLoadOutcomes = false;
          result.forEach((x) => {
            this.outcomes.push({ label: x.outcome, value: x });
          });
        })
        .catch((ex) => {
          this.isBusyLoadOutcomes = false;
          this.loadOutcomesError = true;
          this.messageService.add(
            Message.Error(
              'An error occurred while loading the feedback outcomes.',
              'Supplier Feedback',
            ),
          );
        });
    });
  }

  back() {
    if (this.backTo) this.router.navigate([this.backTo]);
    else this.router.navigate(['/app/supplierFeedback']);
  }

  onResolveFeedback() {
    this.saveOutcomeDetails.Id = this.selectedOutcome.id;

    this.feedbackService.resolveFeedback(this.saveOutcomeDetails).then(
      (res) => {
        this.feedback.resolvedTimeStamp = res as any;
      },
      (err) => {
        this.messageService.add(Message.Error(err, 'Error'));
      },
    );
  }

  onSubmit() {
    if (!this.form.valid) {
      this.messageControl.markAsTouched();
      return;
    }

    this.feedbackService.addFeedbackDetail(this.saveFeedbackDetails).then(
      (res) => {
        this.feedbackService.get(this.id).then((result) => {
          this.feedback = result;
        });
        this.saveFeedbackDetails.text = '';
        this.newMessageform.reset();
      },
      (err) => {
        this.messageService.add(Message.Error(err, 'Error'));
      },
    );
  }
}
